import React from "react";
import { graphql } from "gatsby";
import {
  PureFeaturedLocalVideo,
  PureFeaturedVideo,
} from "../../design-system/Slices/SliceFeaturedVideo/SliceFeaturedVideo";

/**
 * @typedef {import("@prismicio/client").Content.FeaturedVideoSlice} FeaturedVideoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FeaturedVideoSlice>} FeaturedVideoProps
 * @param { FeaturedVideoProps }
 */
interface FeaturedVideoProps {
  slice: any;
}

const FeaturedVideo = ({ slice }: FeaturedVideoProps) => {
  const variant = slice.variation;

  return variant === "default" ? (
    <PureFeaturedVideo
      vidId={slice.primary.video_id}
      fullWidth={slice.primary.full_width}
      rounded={slice.primary.rounded}
      shadows={slice.primary.shadows}
    />
  ) : (
    <PureFeaturedLocalVideo
      videoUrl={slice.primary.featured_video.url}
      videoPoster={
        slice.primary.video_poster.localFile?.childImageSharp.gatsbyImageData
          .images.fallback.src || null
      }
      rounded={slice.primary.rounded}
      shadows={slice.primary.shadows}
      loopVideo={slice.primary.loop_video}
      muteVideo={slice.primary.mute_video}
      showControls={slice.primary.show_video_controls}
      autoPlay={slice.primary.video_auto_plays}
      videoSize={slice.primary.video_size}
    />
  );
};

export default FeaturedVideo;

export const query = graphql`
  fragment FeaturedVideoDefault on PrismicFeaturedVideoDefault {
    id
    slice_label
    slice_type
    variation
    primary {
      full_width
      rounded
      shadows
      video_id
    }
  }

  fragment FeaturedLocalVideo on PrismicFeaturedVideoLocalVideo {
    id
    slice_label
    slice_type
    variation
    primary {
      featured_video {
        url
        id
        type
      }
      video_poster {
        alt
        url
        localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 80
              width: 1080
              webpOptions: { quality: 95 }
              jpgOptions: { quality: 80 }
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
      loop_video
      mute_video
      rounded
      shadows
      show_video_controls
      video_auto_plays
      video_size
    }
  }
`;
